<template>
  <div class="">
    <div class="d-flex m-body">
      <el-button class="btn-tab w-50" plain :class="activeTab === 0 ? 'btn-active' : ''"  @click="activeTab = 0,resetDataOrder(),activeStep = 0">Lên đơn hàng</el-button>
      <el-button class="btn-tab w-50" plain :class="activeTab === 1 ? 'btn-active' : ''" @click="activeTab =1, getOrdersHistory()">Lịch sử lên đơn</el-button>
    </div>
    <div v-if="activeTab === 0" style="max-height: calc(100vh - 168px);overflow: auto;min-height: calc(100vh - 168px);">
      <div class="d-flex justify-content-center my-12 mx-12">
        <el-steps class="step-custom" style="width: 230px" :active="activeStep" finish-status="success" align-center>
          <el-step />
          <el-step />
          <el-step />
        </el-steps>
      </div>
      <div class="mt-3">
        <div class="mx-12" v-if="activeStep === 0">
          <div>
            <span class="fw-bold">Tên khách hàng<span class="text-danger">*</span></span>
            <el-input class="mt-2 input-mx-8px" placeholder="Thêm tên khách hàng" size="small" v-model="orderParam.customer_name" ></el-input>
          </div>
          <div class="mt-12px">
            <span class="fw-bold">Số điện thoại<span class="text-danger">*</span></span>
            <el-input class="mt-2 input-mx-8px" placeholder="Thêm số điện thoại khách hàng" size="small" v-model="orderParam.customer_phone" @input="getHistoryPhone()" @keypress.native="isNumber($event)" :maxlength="11" ></el-input>
          </div>
          <div class="mt-12px">
            <span class="fw-bold">Địa chỉ<span class="text-danger">*</span></span>
            <div v-if="infoSuggest.length" class="border p-2" style="border-radius: 4px">
              <div class="font-weight-600">Địa chỉ đơn đặt hàng gần nhất</div>
              <div v-for="cus in infoSuggest" :key="cus._id" class="mt-1">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">{{ cus.name }}</div>
                  <el-tooltip class="item" effect="dark" content="Sử dụng thông tin" placement="top">
                    <el-button type="success" size="mini" icon="el-icon-plus" style="padding: 3px 5px" @click="useInfoSuggest(cus)"></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="Bỏ thông tin" placement="top">
                    <el-button class="ms-1" type="danger" size="mini" icon="el-icon-close" style="padding: 3px 5px" @click="infoSuggest = []"></el-button>
                  </el-tooltip>
                </div>
                <div class="mt-1 mb-1">{{ cus.phone }}</div>
                <div>
                  {{ [cus.address, (app.localData.wards[cus.wardId] || {}).name || '', (app.localData.districts[cus.districtId] || {}).name || '', (app.localData.provinces[cus.provinceId] || {}).name || ''].filter(Boolean).join(', ') }}
                </div>
              </div>
            </div>
            <el-input class="mt-2 input-mx-8px" type="textarea" row="3" placeholder="Thêm địa chỉ chi tiết" size="small" v-model="orderParam.customer_address"></el-input>
            <div class="mt-2">
              <multiselect
                class="pointer"
                selectedLabel=""
                deselectLabel=""
                selectLabel=""
                v-model="provincesSelected"
                :options="provinces"
                @input="chooseProvince('')"
                placeholder="Tỉnh, Thành Phố"
                label="name"
                track-by="name">
              </multiselect>
            </div>
            <div class="mt-2">
              <multiselect
                selectedLabel=""
                deselectLabel=""
                selectLabel=""
                :options="districts"
                v-model="districtsSelected"
                placeholder="Quận, Huyện"
                class="pointer"

                label="name"
                track-by="name"
                @input="chooseDistrict('')"
              >
              </multiselect>
            </div>
            <div class="mt-2">
              <multiselect
                class="pointer"
                selectedLabel=""
                deselectLabel=""
                selectLabel=""
                :options="wards"
                v-model="wardSelected"
                :showPointer="true"
                @input="chooseWard('')"
                label="name"
                placeholder="Phường Xã"
                track-by="name">
                <span class="text-danger" slot="noOptions">Bạn chưa chọn quận, huyện</span>
              </multiselect>
            </div>
          </div>
          <div class="mt-12px">
            <span class="fw-bold">Ghi chú</span>
            <el-input class="mt-2 input-mx-8px" type="textarea" row="3" placeholder="Yêu cầu của khách hàng" size="small" v-model="orderParam.note_customer"></el-input>
          </div>
        </div>
        <div v-if="activeStep === 1" >
          <div class="d-flex m-body">
            <div class="w-150px">
              <span class="fw-bold">Kho trừ tồn<span class="text-danger">*</span></span>
              <el-select class="mt-2 input-mx-8px" v-model="selectedWarehouse" placeholder="Select" size="small">
                <el-option
                  v-for="item in warehouses"
                  :key="item.value"
                  :label="item.name"
                  :value="item.wid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="ps-2">
              <span class="fw-bold">Giá bán<span class="text-danger">*</span></span>
              <el-select class="mt-2 input-mx-8px" v-model="price_policy" placeholder="Select" size="small">
                <el-option
                  v-for="item in options_price_policy"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="mt-12px m-body">
            <span class="fw-bold">Sản phẩm<span class="text-danger">*</span></span>
            <div class="position-relative">
              <el-input class="mt-2" placeholder="Thêm sản phẩm" size="small" v-model="searchProduct" @input="searchProductWid">
                <template slot="prefix">
                  <IconV2 class="mt-2" name="v2-search"/>
                </template>
              </el-input>
              <div v-if="activeSearch  && loadingSearch === false" class="search-suggestions">
                <div>
                  <div role="button" v-for="(product, index) of listSearchedPrd" :key="index" class="add-prd p-8 border-bottom">
                    <div class="d-flex justify-content-between align-items-center"
                         @click="addProductToOrder(product),activeSearch = null;searchProduct = ''">
                      <div v-if="product.type === 'combo'" class="p-1 d-flex justify-content-center w-100 align-items-center">
                        <div>
                          <el-image style="height: 64px; width: 64px; border-radius: 4px;border: 1px solid #EAECF2;" :src="product.image"></el-image>
                        </div>
                        <div class="ms-2 flex-grow-1" style="width: 175px">
                          <div v-if="product.type === 'combo'" class="combo">COMBO</div>
                          <span class="text-blue500 fw-bold text-ellipsis-1-line">{{ product.name }}</span>
                          <div class="d-flex">
                            <div class="pe-1" style="width: 60% !important; border-right: 1px solid rgba(220, 223, 233, 0.5)">
                              <el-tooltip class="item" effect="dark" :content="`${ product.code }`" placement="top">
                                <span class="text-ellipsis-1-line">{{ product.code }}</span>
                              </el-tooltip>
                            </div>
                            <div class="ms-2"> {{ new Intl.NumberFormat("vi-VN", {
                              style: "currency",
                              currency: "VND"
                            }).format(product.retailPrice) }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="p-1 d-flex justify-content-center w-100">
                        <div>
                          <el-image style="height: 64px; width: 64px; border-radius: 4px;border: 1px solid #EAECF2;" :src="product.image"></el-image>
                        </div>
                        <div class="ms-2 flex-grow-1" style="width: 175px">
                          <span class="text-blue500 fw-bold text-ellipsis-2-line">{{ product.name }}</span>
                          <div class="d-flex">
                            <div class="pe-1" style="width: 60% !important; border-right: 1px solid rgba(220, 223, 233, 0.5)">
                              <el-tooltip class="item" effect="dark" :content="`${ product.code }`" placement="top">
                                <span class="text-ellipsis-1-line">{{ product.code }}</span>
                              </el-tooltip>
                            </div>
                            <div class="ms-2"> {{ new Intl.NumberFormat("vi-VN", {
                              style: "currency",
                              currency: "VND"
                              }).format(product.retailPrice) }}
                            </div>
                          </div>
                          <div class="mt-2 pt-1" style="border-top: 1px solid rgba(220, 223, 233, 0.5);font-size: 12px">
                            <div class="d-block">Tồn kho: {{ (app.localData.storeProduct[product.code][selectedWarehouse] || {}).total }} - Giữ hàng: {{ (app.localData.storeProduct[product.code][selectedWarehouse] || {}).book }} </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="orderParam.items.length > 0" class="m-body">
            <div v-for="(product, index) of orderParam.items" :key="index" class="mt-2 prd-choose">
              <div class="d-flex pb-1" style="border-bottom: 1px solid rgba(220, 223, 233, 0.5)">
                <div>
                  <el-image style="height: 64px; width: 64px; border-radius: 4px;border: 1px solid #EAECF2;" :src="product.image"></el-image>
                </div>
                <div class="ms-1 flex-grow-1">
                  <span class="text-primary fw-bold text-ellipsis-2-line">{{ product.name }}</span>
                  <div class="d-flex pt-1">
                    <div class="d-flex align-items-center pe-1" style="width: 50% !important; border-right: 1px solid rgba(220, 223, 233, 0.5)">
                      <span class="text-ellipsis-1-line">{{ product.code }}</span>
                    </div>
                    <el-input v-if="price_policy === 'retail_price'" size="mini" @input="handleInputFormat($event,'product',product)" @keypress.native="isNumber($event)" class="ms-1 input-center" :value="separateNumberByThousand(product.retailPrice)" style="width: 40%"></el-input>
                    <el-input v-else size="mini" class="ms-1 input-center" @input="handleInputFormat($event,'product',product)" @keypress.native="isNumber($event)" :value="separateNumberByThousand(product.wholesalePrice)" style="width: 40%"></el-input>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-lg-between pt-2 align-items-center">
                <div class="d-flex align-items-center">
                  <div>Số lượng:</div>
                  <el-input size="mini" class="ms-2 input-center" @keypress.native="isNumber($event)" @input="updateOrderSwItems($event, product.code)" v-model="product.amount" style="width: 30%;"></el-input>
                </div>
                <div class="text-danger" role="button" style="font-weight: 600" @click="removeProductFromOrder(product.code)">Xóa</div>
              </div>
            </div>
          </div>
          <div v-else class="border mt-2 py-12 empty-items m-body" >
            <el-image class="rounded" :src="'assets/images/empty_product.svg'"
                      style="height: 68px; min-width: 68px;object-fit: cover"></el-image>
            <span>Đơn hàng chưa có sản phẩm</span>
          </div>
          <div class="mt-12px m-body">
            <span class="fw-bold">Tổng tiền</span>
            <el-input class="mt-2 input-mx-8px" :value="separateNumberByThousand(totalNoFee)" :disabled="true" size="small" placeholder="Tổng tiền sẽ được tính tự động">
              <template slot="suffix">
                <div style="padding-top: 5px">đ</div>
              </template>
            </el-input>
            <div class="mt-2 d-flex justify-content-lg-between">
              <div class="me-2">
                <el-input class="input-discount input-mx-8px" @keypress.native="isNumber($event)" v-model="discount" @input="handleInputFormat($event,'discount')" placeholder="Chiết khấu" size="small">
                  <template slot="suffix">
                    <div class="d-flex" style="padding-top: 6px">
                      <el-button
                        size="mini"
                        style="padding: 3px !important; width: 20px"
                        :class="orderParam.typeDiscount === 'VND' ? 'btn-active-1' : ''"
                        @click="orderParam.typeDiscount = 'VND'"
                      >đ</el-button>
                      <el-button
                        size="mini"
                        style="padding: 3px !important; margin-left: 3px;width: 20px"
                        :class="orderParam.typeDiscount === 'percent' ? 'btn-active-1' : ''"
                        @click="orderParam.typeDiscount = 'percent'"
                      >%</el-button>
                    </div>
                  </template>
                </el-input>
              </div>
              <el-input v-model="paid" class="input-mx-8px" @keypress.native="isNumber($event)" @input="handleInputFormat($event,'paid')"  placeholder="Trả trước" size="small">
                <template slot="suffix">
                  <div style="padding-top: 6px">đ</div>
                </template>
              </el-input>
            </div>
          </div>
          <div class="mt-12px border-top border-bottom" style="height: 8px;background-color: rgba(234, 236, 242, 0.3)" ></div>
          <div class="mt-2 m-body">
            <span class="fw-bold">Kiện hàng</span>
            <div class="mt-2 d-flex justify-content-lg-between">
              <el-input class="me-2 input-mx-8px" v-model="orderParam.package.width" @keypress.native="isNumber($event)" placeholder="Chiều dài" size="small">
                <template slot="suffix">
                  <div style="padding-top: 5px">cm</div>
                </template>
              </el-input>
              <el-input class="input-mx-8px" v-model="orderParam.package.length" @keypress.native="isNumber($event)" placeholder="Chiều rộng" size="small">
                <template slot="suffix">
                  <div style="padding-top: 5px">cm</div>
                </template>
              </el-input>
            </div>
            <div class="mt-2 d-flex justify-content-lg-between">
              <el-input class="me-2 input-mx-8px" v-model="orderParam.package.height" @keypress.native="isNumber($event)" placeholder="Chiết cao" size="small">
                <template slot="suffix">
                  <div style="padding-top: 5px">cm</div>
                </template>
              </el-input>
              <el-input class="input-mx-8px" v-model="orderParam.package.weight" @keypress.native="isNumber($event)" placeholder="Khối lượng" size="small">
                <template slot="suffix">
                  <div style="padding-top: 5px">kg</div>
                </template>
              </el-input>
            </div>
          </div>
        </div>
        <div v-if="activeStep === 2">
          <div class="m-body">
            <div class="fw-bold">Hình thức<span class="text-danger">*</span></div>
            <el-select class="mt-2 w-100 input-mx-8px" v-model="orderParam.logistic" placeholder="Chọn phương thức vận chuyển" size="small">
              <el-option
                :key="'TVC'"
                :label="'Tự vận chuyển'"
                :value="'TVC'">
              </el-option>
              <el-option
                v-for="item in logisticItems.filter(s => s.connected)"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-input class="mt-2 input-mx-8px" v-model="shipping_fee" @input="handleInputFormat($event,'shippingFee')" placeholder="Nhập phí vận chuyển" size="small">
              <template slot="suffix">
                <div style="padding-top: 6px">đ</div>
              </template>
            </el-input>
          </div>
          <div class="mt-12px m-body">
            <div class="fw-bold">Phụ thu</div>
            <el-input class="mt-2 input-mx-8px" v-model="otherFee" @input="handleInputFormat($event,'otherFee')" placeholder="Nhập phụ thu" size="small">
              <template slot="suffix">
                <div style="padding-top: 6px">đ</div>
              </template>
            </el-input>
          </div>
          <div class="mt-12px m-body">
            <div class="fw-bold">Nhãn đơn hàng</div>
            <el-select class="mt-2 input-mx-8px w-100" v-model="tag_logistic" placeholder="Chọn nhãn đơn hàng" size="small">
              <el-option
                v-for="item in options_tag_logistic_computer"
                :key="item.value"
                :label="item.text"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="mt-12px m-body">
            <div class="fw-bold">Người trả phí vận chuyển<span class="text-danger">*</span></div>
            <div class="d-flex mt-2">
              <el-button :class="orderParam.payment_type_id === 1 ? 'btn-active':''" class="w-50 me-1" size="small" @click="orderParam.payment_type_id = 1">Người bán</el-button>
              <el-button :class="orderParam.payment_type_id === 2 ? 'btn-active':''" class="w-50 ms-1" size="small" @click="orderParam.payment_type_id = 2">Người mua</el-button>
            </div>
          </div>
          <div class="mt-12px m-body">
            <div class="fw-bold">Ghi chú cho đơn vị vận chuyển</div>
            <el-input class="mt-2 input-mx-8px" type="textarea" row="3" placeholder="Thêm thông tin ghi chú" size="small" v-model="orderParam.note_shipper"></el-input>
          </div>
          <div class="mt-12px border-top border-bottom" style="height: 8px;background-color: rgba(234, 236, 242, 0.3)" ></div>
          <div class="mt-12px m-body">
            <div class="d-flex justify-content-lg-between">
              <div>Chính sách giá:</div>
              <div class="font-weight-600">{{ price_policy === 'retail_price' ? 'Bán lẻ' : 'Bán buôn'}}</div>
            </div>
            <div class="mt-2 d-flex justify-content-lg-between">
              <div>Tổng tiền hàng:</div>
              <div class="font-weight-600">{{ separateNumberByThousand(totalNoFee) }} đ</div>
            </div>
            <div class="mt-2 d-flex justify-content-lg-between">
              <div>Chiết khấu:</div>
              <div class="font-weight-600">{{ orderParam.typeDiscount === 'VND' ? `${separateNumberByThousand(orderParam.discount || 0)} đ` : `${orderParam.discount || 0}%` }}</div>
            </div>
            <div class="mt-2 d-flex justify-content-lg-between">
              <div>Khách trả trước:</div>
              <div class="font-weight-600">{{ separateNumberByThousand(orderParam.paid || 0) }} đ</div>
            </div>
            <div class="mt-2 d-flex justify-content-lg-between">
              <div>Phụ thu:</div>
              <div class="font-weight-600">{{ separateNumberByThousand(orderParam.otherFee || 0) }} đ</div>
            </div>
            <div class="mt-2 d-flex justify-content-lg-between">
              <div>Phí vận chuyển:</div>
              <div class="font-weight-600">{{ separateNumberByThousand(orderParam.shipping_fee || 0) }} đ</div>
            </div>
            <div class="mt-2 pb-1 d-flex justify-content-lg-between border-bottom">
              <div>Tiền COD:</div>
              <div class="font-weight-600">{{ separateNumberByThousand(orderParam.pickMoney || 0) }} đ</div>
            </div>
            <div class="mt-2 d-flex justify-content-lg-between">
              <div class="fw-bold">Doanh thu đơn hàng:</div>
              <div class="font-weight-600">{{ orderParam.logistic ==="TVC" && orderParam.payment_type_id === 1 ? separateNumberByThousand(orderParam.totalPrice-(Number(orderParam.shipping_fee) || 0)) : separateNumberByThousand(orderParam.totalPrice) }} đ</div>
            </div>
          </div>
          <div class="mt-12px border-top border-bottom" style="height: 8px;background-color: rgba(234, 236, 242, 0.3)" ></div>
        </div>
      </div>
    </div>
    <div v-if="activeTab === 0" class="px-12 py-12 border-top">
      <div class="d-flex justify-content-lg-end w-100">
        <el-button v-if="activeStep != 0" size="small"  @click="returnStep">Quay lại</el-button>
        <el-button size="small" type="primary" @click="nextStep" :disabled="disabledBtnNextStep">{{ activeStep === 2 ? 'Hoàn thành' : 'Tiếp tục' }}</el-button>
      </div>
    </div>
    <div v-if="activeTab === 1" style="max-height: calc(100vh - 116px);overflow: auto;min-height: calc(100vh - 116px);">
      <div v-if="ordersHistory.length">
        <div v-for="order in ordersHistory" :key="order.code" class="mt-12px font-14">
          <div class="m-body">
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-grey700">{{ convertTime(order.createdAt) }}</div>
              <el-badge class="fw-semibold font-size-11 px-1"
                        :style="{color: app.colorOrder[order.state], 'background-color': setTransparencyHex(app.colorOrder[order.state],0.2),'border-color': setTransparencyHex(app.colorOrder[order.state],0.2),'border-radius':'4px','margin-top': '2px'}">
                {{ order.state }}
              </el-badge>
            </div>
            <div class="d-flex align-items-center border-bottom" style="margin-top: 6px;padding-bottom: 6px">
              <div class="font-weight-600 flex-grow-1">Mã đơn hàng:</div>
              <div class="text-primary font-weight-600" role="button" @click="showOrderDetail(order)">{{ order.code }}</div>
              <div @click="copy(order.code)" role="button">
                <IconV2
                  class="ms-1"
                  name="v2-copy"
                  style="opacity: 70%;"
                />
              </div>
            </div>
            <div>
              <div class="font-weight-600 mt-2" style="color: rgba(122,127,131,0.72);">Liên hệ</div>
              <div class="mt-1">
                <span class="font-weight-600 me-1">Số điện thoại:</span>
                <span>{{ order.customer.phone }}</span>
              </div>
              <div class="mt-1">
                <span class="font-weight-600 me-1">Địa chỉ:</span>
                <span>
              {{ [order.customer.address,app.localData.wards[order.customer.wardId].name || '',app.localData.districts[order.customer.districtId].name || '',app.localData.provinces[order.customer.provinceId].name || ''].join(',') }}
            </span>
              </div>
              <div class="font-weight-600 mt-2" style="color: rgba(122,127,131,0.72);">Sản phẩm</div>
              <div class="mt-1 border-bottom pb-2" v-if="order.swItems">
                <div class="p-2 items d-flex align-items-center">
                  <div style="height: 54px">
                    <el-image style="height: 54px; width: 54px; border-radius: 4px;border: 1px solid #EAECF2;" :src="order.swItems[0].image"></el-image>
                  </div>
                  <div class="ms-2 font-12 ">
                    <span class="fw-bold text-ellipsis-2-line">{{ order.swItems[0].name }}</span>
                    <div style="opacity: 70%">Số lượng: {{ order.swItems[0].amount }} x {{ order.price_policy === "retail_price" ? separateNumberByThousand(order.swItems[0].price) : separateNumberByThousand(order.swItems[0].wholesale_price) }} đ</div>
                  </div>
                </div>
                <div v-if="order.swItems.length > 1" class="p-2 items text-center text-primary" style="margin-top: 6px" @click="showOrderDetail(order)" role="button">
                  +{{ order.swItems.length -1 }} sản phẩm khác
                </div>
              </div>
            </div>
            <div>
              <div class="mt-2 d-flex justify-content-lg-between font-weight-600">
                <div>Tổng tiền:</div>
                <div>{{ separateNumberByThousand(order.totalPrice) }} đ</div>
              </div>
              <div class="mt-2 d-flex justify-content-lg-between font-weight-600">
                <div>Phí vận chuyển:</div>
                <div>{{ separateNumberByThousand(order.shippingFee) }} đ</div>
              </div>
              <div class="mt-2 d-flex justify-content-lg-between font-weight-600">
                <div>Phương thức thanh toán:</div>
                <div>{{ order.selectedPayment }}</div>
              </div>
              <div class="mt-2 d-flex justify-content-lg-between font-weight-600">
                <div>Thành tiền:</div>
                <div>{{ separateNumberByThousand(order.pickMoney) }} đ</div>
              </div>
            </div>
          </div>
          <div class="mt-12px border-top border-bottom" style="height: 8px;background-color: rgba(234, 236, 242, 0.3)" ></div>
        </div>
      </div>
      <div v-else class="mt-2 d-flex flex-column">
        <div class="empty-items flex-grow-1">
          <el-image class="rounded" :src="'assets/images/empty_product.svg'"
                    style="height: 68px; min-width: 68px;object-fit: cover; margin-top: 50px"></el-image>
          <span>Bạn chưa có đơn hàng nào !</span>
        </div>
      </div>
    </div>
    <el-dialog class="hidden-header" width="60vw" v-if="showDetailOrder" :visible.sync="showDetailOrder" >
      <OrderDetailV2 :order="orderDetail" @close="showDetailOrder = false"></OrderDetailV2>
    </el-dialog>
  </div>
</template>

<script>
import VueMultiselect from "../common/vue-multiselect/src/Multiselect";
import OrderDetailV2 from "./OrderDetailV2";
export default {
  name: "CreateOrder",
  components: { OrderDetailV2, multiselect: VueMultiselect },
  props: ["conversation"],
  data(){
    return{
      activeTab:0,
      activeStep: 0,
      provinces: [],
      provincesSelected: null,
      districts: [],
      districtsSelected: null,
      wards: [],
      wardSelected: null,
      orderParam: {
        company_id: "",
        createdBy: "",
        customer_address: "",
        customer_district_id: null,
        customer_name: "",
        customer_phone: "",
        customer_phoneExtend: "",
        customer_province_id: null,
        customer_ward_id: null,
        items: [],
        // note: "",
        note_customer: "",
        note_shipper: "",
        price_policy: "retail_price",
        paid: null,
        otherFee: null,
        payment_type_id: 1,
        tag_logistic: { value: "", text: "" },
        package: { height: 10, width: 10, length: 10, weight: 0.2 },
        logistic: "",
        source: "swZalo",
        channel: "Salework", /* Nguồn gửi */
        discount: null, /* Chiết khấu */
        shipping_fee: null, /* Phí vận chuyển */
        contactDate: "",
        totalPrice: 0,
        typeDiscount: 'VND',
      },
      warehouses: [],
      selectedWarehouse: null,
      options_price_policy: [
        { value: "retail_price", text: "Bán lẻ" },
        { value: "wholesale_price", text: "Bán buôn" }
      ],
      price_policy: 'retail_price',
      searchProduct:null,
      activeSearch: null,
      listSearchedPrd: [],
      loadingSearch: null,
      logisticItems: [
        {
          id: "JNT",
          name: "J&T Express",
          price: "",
          selected: false,
          image: "https://vinh-cat.com.vn/wp-content/uploads/2021/01/article_1564050459_674.png",
          connected: false
        },
        {
          id: "GHN",
          name: "Giao hàng nhanh",
          price: "",
          selected: false,
          image: "https://help.shopee.vn/servlet/rtaImage?eid=ka05j000000oXwC&feoid=00N6F00000Rj6Gl&refid=0EM6F000007mCj1",
          connected: false
        },
        {
          id: "SUPERSHIP",
          name: "Super Ship",
          price: "",
          selected: false,
          image: "https://play-lh.googleusercontent.com/qL5rWNpSrrCD2NIoXIBPy9iFw1bGFWq4R6G0Htj27dm0LHCle8NXqXFSz9BOBsgQJc8",
          connected: false
        },
        {
          id: "Viettel Post",
          name: "Viettel Post",
          price: "",
          selected: false,
          image: "https://viettelpost.com.vn/wp-content/uploads/2020/03/logo-380x270.jpg",
          connected: false
        },
        {
          id: "GHTK",
          name: "Giao hàng tiết kiệm",
          price: "",
          selected: false,
          image: "https://cdn.nhanh.vn/cdn/store/26/artCT/42374/giao_hang_tiet_kiem.png",
          connected: false
        },
        {
          id: "CNTSHIP",
          name: "CNTSHIP(nội thành)",
          price: "",
          selected: false,
          image: "https://cdn.nhanh.vn/cdn/store/26/artCT/42374/giao_hang_tiet_kiem.png",
          connected: false
        },
        { id: "sps", name: "Ninja van", price: "", selected: false, image: "", connected: false },
        {
          id: "Shopee Xpress",
          name: "Shopee Xpress",
          price: "",
          selected: false,
          image: "https://deo.shopeemobile.com/shopee/shopee-spx-live-vn/static/media/logo.6f321ec3.svg",
          connected: false
        },
        {
          id: "AHAMOVE",
          name: "Ahamove",
          price: "",
          selected: false,
          image: "https://www.ahamove.com/static/icons/Logo.svg",
          connected: false
        }
      ],
      options_tag_logistic: [
        { value: 1, text: "Dễ vỡ" },
        { value: 7, text: "Nông sản/thực phẩm khô" }
      ],
      tag_logistic: "",
      loading : false,
      infoSuggest:[],
      discount: null,
      paid: null,
      otherFee: null,
      shipping_fee: null, /* Phí vận chuyển */
      ordersHistory:[],
      showDetailOrder: false,
      orderDetail:{}
    }
  },
  watch:{
    "app.localData.provinces": "setupMultiselect",
    "app.localData.warehouses": "getWarehouses",
    "orderParam.discount": "updateTotalPrice",
    "orderParam.paid": "updateTotalPrice",
    "app.localData": "getShippingUnit",
    "orderParam.shipping_fee": "updateTotalPrice",
    "orderParam.otherFee": "updateTotalPrice",
    "orderParam.payment_type_id": "updateTotalPrice",
    "conversation": function(){
      if(this.activeTab === 1){
        this.getOrdersHistory()
      }
      this.orderParam.customer_name = '';
      this.orderParam.customer_phone = '';
      this.orderParam.customer_address = '';
      this.orderParam.customer_province_id = '';
      this.provincesSelected = null
      this.chooseProvince(null);
      this.infoSuggest = []
    }
  },
  mounted() {
    if (Object.keys(this.app.localData).length === 0) {
      this.fetchInitData();
    } else {
      this.setupMultiselect(this.app.localData.provinces);
      this.getShippingUnit();
      this.getWarehouses();
    }
  },
  computed: {
    options_tag_logistic_computer() {
      if (this.orderParam.logistic === "GHTK") {
        let data = [...this.options_tag_logistic];
        data.push({ value: 17, text: "Giao hàng 1 phần chọn sản phẩm" });
        data.push({ value: 18, text: "Giao hàng 1 phần đổi trả hàng" });
        return data;
      }
      return this.options_tag_logistic;
    },
    totalNoFee(){
      let totalCost = this.orderParam.items.reduce((agg, val) => {
        if(this.orderParam.price_policy == 'retail_price'){
          agg += parseInt(val.retailPrice)*parseInt(val.amount || 0)
        } else{
          if(!val.wholesalePrice) val.wholesalePrice = 0
          agg += parseInt(val.wholesalePrice)*parseInt(val.amount || 0)
        }
        return agg
      }, 0);
      return totalCost
    },
    disabledBtnNextStep(){
      if(this.activeStep === 0){
        if( !this.orderParam.customer_name.trim()  || !this.orderParam.customer_phone.trim()
          || !this.provincesSelected || !this.provincesSelected.provinceId
          || !this.districtsSelected || !this.districtsSelected.code
          || !this.wardSelected || !this.wardSelected.code || !this.orderParam.customer_address.trim() ){
          return true
        }
        if (/((^\W\S)?^(([+]84[1-9]{1})|([0][3|5|7|8|9])){1}[0-9]{2})[.]?[0-9]{3}[.]?[0-9]{3}\b/.test(this.orderParam.customer_phone) !== true) {
          return true;
        }
      }
      if(this.activeStep === 1){
        if( !this.orderParam.items.length ){
          return true
        }
        if( this.orderParam.items.filter(s => s.amount === 0).length )
          return true
      }
      if(this.activeStep === 2){
        if( !this.orderParam.logistic )
          return true
      }
      return false
    }
  },
  methods:{
    async nextStep(){
      if(this.activeStep === 1){
        let swItems = this.orderParam.items.map(it => ({
          productCode: it.code,
          amount: parseInt(it.amount),
          price: parseInt(it.retailPrice),
          ...(it.wholesale_price !== undefined ? { wholesale_price: parseInt(it.wholesalePrice) } : {}),
          name:  this.app.localData.products[it.code] ? this.app.localData.products[it.code].name : it.name,
          image: this.app.localData.products[it.code] ? this.app.localData.products[it.code].image : it.image,
          ...(it.type === 'combo' ? { salework: it.salework} : {}),
          ...(this.app.localData.products[it.code] ? { cost: this.app.localData.products[it.code].cost } : {}),
          ...(this.app.localData.products[it.code] ? { currentAmount: this.app.localData.storeProduct[it.code] && this.app.localData.storeProduct[it.code][this.selectedWarehouse] ? this.app.localData.storeProduct[it.code][this.selectedWarehouse].total : 0, } : {}),
          ...(this.app.localData.products[it.code] ? { bid: this.app.localData.products[it.code].warehouses.find(i => i.wid === this.selectedWarehouse) ? this.app.localData.products[it.code].warehouses.find(i => i.wid === this.selectedWarehouse).bid : 'BinDefault', } : {}),
        }));
        let currentWarehouse = this.selectedWarehouse;
        for(let it of swItems){
          if (!this.app.localData.settings.addOrder) {
            if(!it.salework){
              if((this.app.localData.storeProduct[it.productCode][currentWarehouse].total + this.app.localData.storeProduct[it.productCode][currentWarehouse].exp_amount - this.app.localData.storeProduct[it.productCode][currentWarehouse].book - this.app.localData.storeProduct[it.productCode][currentWarehouse].wait - parseInt(it.amount))<0){
                this.alert("error", `Sản phẩm ${it.productCode} hiện đang hết hàng`);
                return
              }
            }
            else {
              for(let prd of it.salework){
                if((this.app.localData.storeProduct[prd.code][currentWarehouse].total + this.app.localData.storeProduct[prd.code][currentWarehouse].exp_amount - this.app.localData.storeProduct[prd.code][currentWarehouse].book - this.app.localData.storeProduct[prd.code][currentWarehouse].wait - Number(it.amount)*Number(prd.amount))<0){
                  this.alert("error", `Sản phẩm ${prd.code} của Combo ${it.productCode} hiện đang hết hàng`);
                  return
                }
              }
            }
          }
        }
      }
      if(this.activeStep === 2){
        let swItems = this.orderParam.items.map(it => ({
          productCode: it.code,
          amount: parseInt(it.amount),
          price: parseInt(it.retailPrice),
          ...(it.wholesale_price !== undefined ? { wholesale_price: parseInt(it.wholesalePrice) } : {}),
          name:  this.app.localData.products[it.code] ? this.app.localData.products[it.code].name : it.name,
          image: this.app.localData.products[it.code] ? this.app.localData.products[it.code].image : it.image,
          ...(it.type === 'combo' ? { salework: it.salework} : {}),
          ...(this.app.localData.products[it.code] ? { cost: this.app.localData.products[it.code].cost } : {}),
          ...(this.app.localData.products[it.code] ? { currentAmount: this.app.localData.storeProduct[it.code] && this.app.localData.storeProduct[it.code][this.selectedWarehouse] ? this.app.localData.storeProduct[it.code][this.selectedWarehouse].total : 0, } : {}),
          ...(this.app.localData.products[it.code] ? { bid: this.app.localData.products[it.code].warehouses.find(i => i.wid === this.selectedWarehouse) ? this.app.localData.products[it.code].warehouses.find(i => i.wid === this.selectedWarehouse).bid : 'BinDefault', } : {}),
        }));
        let param = {
          swItems: swItems,
          price_policy: this.price_policy,
          ...(this.tag_logistic != '' ? { tag_logistic: this.tag_logistic } : {}),
          customer_name: this.orderParam.customer_name.trim(),
          customer_phone: this.orderParam.customer_phone,
          channel: 'Salework',
          payment_type_id: this.orderParam.payment_type_id,
          customer_phoneExtend:  '',
          customer_address: this.orderParam.customer_address,
          customer_province_id: this.provincesSelected ? this.provincesSelected.provinceId : '',
          customer_district_id: this.districtsSelected ? this.districtsSelected.code :  '',
          customer_ward_id: this.wardSelected ? this.wardSelected.code : '',
          discount: parseInt(this.orderParam.discount) || 0,
          typeDiscount: this.orderParam.typeDiscount,
          paid: parseInt(this.orderParam.paid) || 0,
          shipping_fee: parseInt(this.orderParam.shipping_fee) || 0,
          logistic: this.orderParam.logistic,
          totalPrice: parseInt(this.orderParam.totalPrice),
          package: this.orderParam.package,
          note_customer: this.orderParam.note_customer,
          note_shipper: this.orderParam.note_shipper,
          note: this.orderParam.note,
          createdBy: this.app.user.swUsername,
          return_storeProduct: true,
          source: 'zalo',
          otherFee: this.orderParam.otherFee || 0,
          company_id: this.app.user.companyCode,
          wid: this.selectedWarehouse,
          pickMoney: parseInt(this.orderParam.pickMoney),
          // ...this.orderDetails.selectedLgx === "AHAMOVE" || estimateFee? {
          //   payment_method: (this.orderDetails.payment_method === 'CASH' && this.orderDetails.payment_type_id == 2) ? 'CASH_BY_RECIPIENT' : this.payment_method,
          //   service_id: serviceType ? serviceType : ''
          // } : {}, /* For ahamove */
          // ...this.orderDetails.selectedLgx != '' && this.orderDetails.deliveryType == 'TPL' ? {
          //   serviceType: this.logisticItems.find(s=> s.id === this.orderDetails.selectedLgx ).serviceType
          // }:{},
          shopId:'SaleworkWarehouse',
          selectedPayment: 'Tiền mặt',
          zaloConversationId : this.conversation.id
        }
        let request = {
          method: "add",
          params: param
        };
        this.loading = true;
        this.$http.post("/api/stock/addOrder", request).then(() => {
          this.alert("success", "Lên đơn thành công");
          this.resetDataOrder()
        }).finally(() => {
          this.loading = false
          this.activeTab = 1
          this.getOrdersHistory()
        });
      }
      if (this.activeStep++ > 1) this.activeStep = 0;
    },
    returnStep(){
      if (this.activeStep-- < 1) this.activeStep = 0;
    },
    async fetchInitData() {
      this.$http.get(`/api/stock/getInitData?companyCode=${this.app.user.companyCode}`).then(initData => {
        let adressCache = JSON.parse(sessionStorage.getItem(this.app.user.companyCode));
        if (adressCache != null) {
          this.app.localData = { ...initData.data, ...adressCache };
        } else {
          this.$http.get("/api/stock/address").then(address => {
            sessionStorage.setItem(this.app.user.companyCode, JSON.stringify(address.data));
            this.app.localData = { ...initData.data, ...address.data };
            this.setupMultiselect(this.app.localData.provinces);
            this.getShippingUnit();
          });
        }
      });
    },
    setupMultiselect(localData) {
      this.provinces = [];
      Object.entries(localData).map(item => {
        this.provinces.push({
          provinceId: item[0],
          name: item[1].name,
          children: item[1].children,
          viettelCode: item[1].viettelCode
        });
      });
    },
    chooseProvince(e) {
      this.orderParam.customer_district_id = null;
      this.orderParam.customer_ward_id = null;
      this.wardSelected = null;
      this.districtsSelected = null;
      this.errorWard = false;
      if (!e) this.orderParam.customer_province_id = this.provincesSelected.provinceId; /*Set province id for order after selected*/
      this.wards = [];
      this.districtsId = this.app.localData.provinces[this.orderParam.customer_province_id || e.provinceId].children;
      this.districts = this.districtsId.map((ele) => {
        return { code: ele, ...this.app.localData.districts[ele] };
      });
      if (e.provinceId) {
        let province = this.app.localData.provinces[e.provinceId];
        this.provincesSelected = {
          children: province.children,
          name: province.name,
          provinceId: e.provinceId,
          viettelCode: province.viettelCode
        }; /*Object Province Selected*/
        this.orderParam.customer_district_id = e.districtId;
        this.chooseDistrict(e);
      }
    },

    chooseDistrict(e) {
      this.orderParam.customer_ward_id = null;
      this.wardSelected = null;
      this.errorWard = false;
      if (!e) this.orderParam.customer_district_id = this.districtsSelected.code;
      //load ward data
      this.wardsId = this.districts.find(item => item.code === e.districtId || item.code === this.orderParam.customer_district_id).children;
      this.wards = this.wardsId.map((ele) => {
        return { code: ele, ...this.app.localData.wards[ele] };
      });

      if (e.provinceId) {
        let district = this.app.localData.districts[e.districtId];
        this.districtsSelected = {
          code: e.districtId,
          name: district.name,
          parent: district.parent,
          children: district.children,
          viettelCode: district.viettelCode
        };
        this.orderParam.customer_ward_id = e.wardId;
        this.chooseWard(e);
      }
    },

    chooseWard(e) {
      this.errorWard = false;
      if (!e) return this.orderParam.customer_ward_id = this.wardSelected.code;
      let ward = this.app.localData.wards[e.wardId];
      this.wardSelected = { code: e.wardId, name: ward.name, parent: ward.parent };
    },
    getWarehouses() {
      if (this.app.localData.warehouses) {
        this.warehouses = Object.values(this.app.localData.warehouses.warehouses);
        this.selectedWarehouse = this.warehouses[0].wid;
      }
    },
    async searchProductWid() {
      if(!this.searchProduct.trim()){
        this.activePrdSearch = null;
        this.listSearchedPrd = [];
        this.loadingSearch = true
        return;
      }
      clearTimeout(this.activeSearch);
      this.activeSearch = setTimeout(async () => {
        await this.getListProduct()
      }, 500);
    },
    async getListProduct(){
      this.loadingSearch = true;
      let data = {}
      data.companyCode = this.app.user.companyCode;
      data.limit = 25;
      data.search = this.searchProduct;
      data.wid = this.selectedWarehouse;
      data.start = 0
      this.$http.post("/api/stock/searchProduct", data).then(data =>{
        this.listSearchedPrd = data.data
        }
      )
      this.loadingSearch = false;
    },
    addProductToOrder(product){
      product.amount = 1;
      let existPrd = this.orderParam.items?.findIndex(prd => prd.code == product.code);
      if(existPrd == -1){
        this.orderParam.items.push(product)
      } else {
        let sw = this.orderParam.items
        sw[existPrd].amount = sw[existPrd].amount + 1
        this.orderParam.items = JSON.parse(JSON.stringify(sw))
      }
      this.updateTotalPrice()
    },
    removeProductFromOrder(code){
      this.orderParam.items = this.orderParam.items.filter(item => item.code != code)
      this.updateTotalPrice()
    },
    updateOrderSwItems(event, code){
      let value = parseInt(event || 0);
      let sw = this.orderParam.items.map(item => {
        if(item.code === code){
          item.amount = value
        }
        return item;
      });
      this.orderParam.items = JSON.parse(JSON.stringify(sw))
      this.updateTotalPrice()
    },
    updateTotalPrice(){
      if (!this.orderParam.items) return;
      this.orderParam.totalPrice = 0
      if(!this.price_policy || this.price_policy === 'retail_price'){
        for(const it of this.orderParam.items){
          this.orderParam.totalPrice += parseInt(it.retailPrice) * parseInt(it.amount || 0);
        }
      } else {
        for(const it of this.orderParam.items){
          if(!it.wholesale_price) it.wholesale_price = 0
          this.orderParam.totalPrice += parseInt(it.wholesalePrice) * parseInt(it.amount || 0);
        }
      }
      let discount = this.orderParam.discount ? parseInt(this.orderParam.discount) : 0
      let otherFee = this.orderParam.otherFee ? parseInt(this.orderParam.otherFee) : 0
      let totalPrice = this.orderParam.typeDiscount === 'VND' ? parseInt(this.orderParam.totalPrice) - discount + otherFee
        : parseInt(this.orderParam.totalPrice) - (discount / 100) * parseInt(this.orderParam.totalPrice) + otherFee;
      this.orderParam.totalPrice = totalPrice > 0 ? Math.round(totalPrice) : 0;
      let paid = this.orderParam.paid ? parseInt(this.orderParam.paid) : 0
      this.orderParam.pickMoney = (totalPrice - paid) > 0 ? Math.round(totalPrice - paid) : 0;
      if (this.orderParam.payment_type_id != 1) {
        let shipping_fee = this.orderParam.shipping_fee ? parseInt(this.orderParam.shipping_fee) : 0
        this.orderParam.pickMoney += shipping_fee;
      }
    },
    getShippingUnit() {
      if (this.app.localData.companyInfo) {
        let lgxSetup = this.app.localData.companyInfo;
        this.logisticItems.forEach(item => {
          if (item.id == "AHAMOVE" && lgxSetup["ahamove"] && lgxSetup["ahamove"]["token"]) {
            item.connected = true;
          }
          if (item.id == "JNT" && lgxSetup["jnt"] && lgxSetup["jnt"]["jntCode"]) {
            item.connected = true;
          }
          if (item.id == "Viettel Post" && lgxSetup["viettelPost"] && lgxSetup["viettelPost"]["vtpToken"]) {
            item.connected = true;
          }
          if (item.id == "GHN" && lgxSetup["ghn"] && lgxSetup["ghn"]["ghnToken"] && lgxSetup["ghn"]["ghnShopId"]) {
            item.connected = true;
          }
          if (item.id == "GHTK" && lgxSetup["ghtk"] && lgxSetup["ghtk"]["ghtkApiToken"] && lgxSetup["ghtk"]["ghtkShopId"]) {
            item.connected = true;
          }
          if (item.id == "SUPERSHIP" && lgxSetup["superShip"] && lgxSetup["superShip"]["superShipToken"]) {
            item.connected = true;
          }
          if (item.id == "CNTSHIP" && lgxSetup["cntShip"] && lgxSetup["cntShip"]["cntShopId"]) {
            item.connected = true;
          }
          if (item.id == "sps" && lgxSetup["ninjaVan"] && lgxSetup["ninjaVan"]["branchID"]) {
            item.connected = true;
          }
          if (item.id == "Shopee Xpress" && lgxSetup["shopeeX"] && lgxSetup["shopeeX"]["userSecret"] && lgxSetup["shopeeX"]["userId"]) {
            item.connected = true;
          }
        });
        this.logisticItems.sort((a, b) => b.connected - a.connected)
      }
    },
    getHistoryPhone(){
      if(this.orderParam.customer_phone.length >= 10){
        this.infoSuggest = []
        this.$http.get("/api/stock/customer", {
          params: {
            phone: this.orderParam.customer_phone,
            zaloConversationId: this.conversation.id
          }
        }).then((resp) => {
          if(resp.data?.orders.length){
            this.infoSuggest.push(resp.data.orders[0].customer)
          }
          else {
            if (!resp.data?.address || !resp.data?.phone) return;
            this.infoSuggest.push(resp.data)
          }

          }
        );
      }
    },
    useInfoSuggest(customer){
      this.orderParam.customer_name = this.orderParam.customer_name != "" ? this.orderParam.customer_name : customer.name;
      this.orderParam.customer_phone = customer.phone;
      this.orderParam.customer_address = customer.address;
      this.orderParam.customer_province_id = customer.provinceId;
      this.chooseProvince(customer);
      this.infoSuggest = []
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    resetDataOrder() {
      /*Reset Data*/
      this.orderParam.tag_logistic = this.tag_logistic = "";
      this.orderParam.items = [];
      this.orderParam.discount = 0;
      this.orderParam.typeDiscount = 'VND';
      this.orderParam.otherFee = 0;
      this.orderParam.note = "";
      this.orderParam.note_customer = "";
      this.orderParam.note_shipper = "";
      this.orderParam.paid = 0;
      this.orderParam.shipping_fee = 0;
      this.orderParam.payment_type_id = 1;
      this.shipping_fee = 0;
      this.discount = 0;
      this.otherFee = 0;
      this.paid = 0
    },
    separateNumberByThousand(number) {
      if (!number)
        number = 0;
      return number.toString().replace(/[^0-9.]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    handleInputFormat(number,type,product){
      let numberType = number.toString().split(',').join('');
      let value = 0;
      switch (type) {
        case 'paid':{
          value = this.separateNumberByThousand(numberType);
          this.paid = value !== '0' ? value : '';
          this.orderParam.paid = Number(numberType);
          break;
        }
        case 'discount':
          if(this.orderParam.typeDiscount !== 'percent'){
            value = this.separateNumberByThousand(numberType);
            this.discount = value !== '0' ? value : '';
            this.orderParam.discount = Number(numberType);
          }
          else {
            if(numberType > 100){
              this.alert("error", "Chiết khấu không được lớn 100");
              this.discount = null;
              this.orderParam.discount = 0;
            }
            else {
              this.discount = numberType;
              this.orderParam.discount = Number(numberType);
            }
          }
          break;
        case 'product':
          value = this.separateNumberByThousand(numberType);
          if(this.price_policy == 'retail_price'){
            product.retailPrice = Number(numberType);
          } else {
            product.wholesalePrice = Number(numberType);
          }
          this.updateTotalPrice()
          break;
        case 'shippingFee':
          value = this.separateNumberByThousand(numberType);
          this.shipping_fee = value !== '0' ? value : '';
          this.orderParam.shipping_fee = Number(numberType);
          break;
        case 'otherFee':
          value = this.separateNumberByThousand(numberType);
          this.otherFee = value !== '0' ? value : '';
          this.orderParam.otherFee = Number(numberType);
          break;
      }
    },
    async getOrdersHistory(){
      this.$http.get("/api/stock/orders", {
        params: {
          zaloConversationId: this.conversation.id
        }
      }).then((resp) => {
        this.ordersHistory = resp.data;
      });
    },
    copy(code) {
      const el = document.createElement("textarea");
      el.value = code;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.alert("success", "Đã sao chép");
    },
    showOrderDetail(order){
      this.orderDetail = order;
      this.showDetailOrder = true;
    }
  }
}
</script>

<style scoped>
.m-body{
  margin-left: 12px;
  margin-right: 12px;
}
.btn-tab{
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0px;
  background: white;
  margin-left: 0px;
}
.btn-active {
  border-color: #094fad;
  color: #094fad;
}
.bottom-fixed{
  width: -webkit-fill-available;
  padding: 8px 12px;
  position: fixed;
  bottom: 0;
  border-top: 1px solid rgb(224, 228, 232);
}
.search-suggestions{
  background-color: white;
  border: 1px solid #d4d4d4;
  width: 100%;
  position: absolute;
  z-index: 999;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 4px;
  margin-top: 2px;
}
.text-ellipsis-2-line {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  max-height: 42px;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-ellipsis-1-line {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  max-height: 21px;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.add-prd{
  color: #9497A5;
  font-size: 14px;
}
.add-prd:hover{
  background: rgba(225, 237, 253, 0.4);
}
.prd-choose{
  background-color: rgba(225, 237, 253, 0.2);
  border-radius: 4px;
  border: 1px solid rgba(234, 236, 242, 1);
  padding: 8px;
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(196, 191, 191);
  border-radius: 8px;
}
.btn-active-1{
  background: rgba(23, 105, 215, 1);
  color: white;
  border: none;
}
.font-weight-600{
  font-weight: 600;
}
.mt-12px{
  margin-top: 12px;
}
.combo{
  color: #9497A5;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  padding: 0 4px;
  background-color: rgba(148, 151, 165, 0.1);
  width: fit-content;
  border-radius: 4px;
}
.empty-items{
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  background: rgba(225, 237, 253, 0.20);
  color: #ABAEBB;
  text-align: center;
}
.items{
  border-radius: 4px;
  border: 1px solid  #EAECF2;
  background: linear-gradient(0deg, rgba(225, 237, 253, 0.20) 0%, rgba(225, 237, 253, 0.20) 100%), #FFF;
}
</style>
